// @TODO: <HEALTH2019>
(function () {
    App.directive('healthComplaintRefundList', healthComplaintRefundListDirective);
    healthComplaintRefundListDirective.$inject = ['Config'];
    
    function healthComplaintRefundListDirective(Config) {
        return {
            restrict: 'E',
            scope: {
                list: '<'
            },
            templateUrl: Config.TEMPLATES_DIR + 'Components/health-complaint-refund-list.html',
            controller: HealthComplaintRefundListController,
            controllerAs: '$ctrl',
            bindToController: true
        }
    }

    HealthComplaintRefundListController.$inject = [];
    function HealthComplaintRefundListController() {
        var self = this;

        self.getRowType = function (row) {
            switch (row.type) {
                case 'COMPLAINT':
                    return 'Reklamacja';
                case 'REFUND_70':
                    return 'Refundacja - zwrot 70% kosztów wizyty';
                case 'REFUND':
                    return 'Zwrot kosztów z powodu niedotrzymania terminów';
            }
        };

        self.toggleRowDetails = function (row) {
            row.showDetails = !row.showDetails;
        }
    }
})();
// @TODO: </HEALTH2019>
